'use client';

import { I18nProvider } from 'react-aria';

export const LocaleProvider = ({
  children,
}: {
  readonly children: React.ReactNode;
}) => {
  return <I18nProvider locale='sv-SE'>{children}</I18nProvider>;
};
